const request = async (fetchWithAuth, url, options) => {
  const response = await fetchWithAuth(url, { mode: 'cors', ...options });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body?.message || 'No se pudo completar la acción');
    error.validation = body?.validation || null;
    error.status = response.status;
    throw error;
  }
  return body;
};

export const createAgentApi = (fetchWithAuth, urlAPI_3) => {
  const base = (botId) => `${urlAPI_3}chatBot/${botId}/agent`;
  return {
    get: (botId) => request(fetchWithAuth, base(botId), { method: 'GET' }),
    save: (botId, agentConfig) =>
      request(fetchWithAuth, base(botId), { method: 'PUT', body: JSON.stringify({ agentConfig }) }),
    test: (botId, { message, state, agentConfig }) =>
      request(fetchWithAuth, `${base(botId)}/test`, {
        method: 'POST',
        body: JSON.stringify({ message, state, agentConfig }),
      }),
    logs: (botId, params = {}) =>
      request(fetchWithAuth, `${base(botId)}/logs?${new URLSearchParams(params).toString()}`, { method: 'GET' }),
    usage: (botId) => request(fetchWithAuth, `${base(botId)}/usage`, { method: 'GET' }),
  };
};
